import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1301_5247)">
        <path
          d="M29.42 16.09L31.71 13.11L28.48 11.19L29.45 7.55L25.73 7L25.24 3.28L21.59 4.2L19.7 0.940002L16.69 3.19L13.7 0.900002L11.78 4.13L8.14 3.16L7.6 6.88L3.87 7.37L5.28 10.34L17.27 6.65L18.22 6.36L18.84 7.14L20.05 8.68L23.23 7.7L24.62 7.27L25.05 8.66L25.36 9.68C25.57 10.36 25.5 11.09 25.17 11.72C25.12 11.81 25.05 11.9 24.99 11.98L25.56 12.15L25.79 12.88L27.87 19.64C28.15 20.54 28.06 21.5 27.61 22.34C27.17 23.17 26.43 23.79 25.52 24.06L25.29 24.13C24.95 24.23 24.6 24.29 24.25 24.29C23.68 24.29 23.1 24.15 22.6 23.88C21.86 23.49 21.3 22.87 20.99 22.11L10.35 25.38C10.52 26.19 10.4 27.02 10.01 27.75C9.91 27.94 9.79 28.12 9.65 28.29L11.63 27.79L13.51 31.05L16.53 28.8L19.51 31.09L21.43 27.86L25.07 28.83L25.61 25.11L29.34 24.61L28.42 20.96L31.68 19.08L29.43 16.06L29.42 16.09Z"
          fill="#5586D4"
        />
        <path
          d="M5.2 11.87L7.74 16.38L21.03 12.29L17.68 8.03L5.2 11.87ZM4.69 17.33L2.58 17.98C2.27 18.08 1.93 18.04 1.64 17.89C1.35 17.74 1.14 17.48 1.04 17.17L0.719999 16.14L4.01 15.13L4.69 17.33Z"
          fill="#1F3E74"
        />
        <path
          d="M20.36 10.1L23.65 9.09L23.96 10.11C24.06 10.42 24.02 10.76 23.87 11.05C23.72 11.34 23.46 11.55 23.15 11.65L21.04 12.3L20.36 10.1ZM24.38 13.32L26.46 20.08C26.62 20.61 26.57 21.18 26.31 21.67C26.05 22.16 25.61 22.53 25.08 22.69L24.85 22.76C24.32 22.92 23.75 22.87 23.26 22.61C22.77 22.35 22.4 21.91 22.24 21.38L21.91 20.31L8.53 24.43L8.86 25.5C9.02 26.03 8.97 26.6 8.71 27.09C8.45 27.58 8.01 27.95 7.48 28.11L7.25 28.18C6.72 28.34 6.15 28.29 5.66 28.03C5.17 27.77 4.8 27.33 4.64 26.8L2.56 20.04L24.39 13.32H24.38Z"
          fill="#1F3E74"
        />
        <path
          d="M9.8 20.68L7.76 20.09L4.48 20.45L4.63 20.93C4.67973 21.0913 4.76134 21.2409 4.87 21.37C4.98 21.5 5.11 21.61 5.26 21.68C5.40792 21.761 5.57172 21.8088 5.74 21.82C5.90833 21.8382 6.07861 21.8212 6.24 21.77L9.82 20.67L9.8 20.68ZM18.59 17.97L19.94 16.34L22.86 14.79L23.02 15.31C23.0717 15.4644 23.0887 15.6283 23.07 15.79C23.0541 15.9511 23.0065 16.1074 22.93 16.25C22.85 16.39 22.75 16.52 22.63 16.62C22.51 16.72 22.36 16.8 22.21 16.85L18.59 17.96V17.97Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1301_5247">
          <rect width={width} height={width} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Icon;
